import ERPShortMessageWarningModal from './ERP-short-message-warning-modal.vue'
export default ERPShortMessageWarningModal
